import { useSyncExternalStore } from "react";
import { auxiliaryStorage } from "./auxiliaryStorage";

export function AuxiliaryStorageStatus() {
  const status = useSyncExternalStore(auxiliaryStorage.subscribe, auxiliaryStorage.getStatus);
  if (status === "ready") return null;
  return <aside className="support-status support-status--wait" role={status === "unavailable" ? "alert" : "status"}>
    <p>{status === "pending" ? "설정·장소·문의 기록을 저장하는 중이에요." : "설정·장소·문의 기록을 읽거나 저장하지 못했어요. 원본은 보존하고 바뀐 내용은 이 화면에 유지해요. 닫기 전에 다시 시도해 주세요."}</p>
    {status === "unavailable" && <button className="button button--ghost" onClick={() => void auxiliaryStorage.hydrate()}>저장 다시 시도</button>}
  </aside>;
}
